import { Routes } from "@angular/router";
import { ContractListComponent } from "./contract-list/contract-list.component";
import { ContractCreateComponent } from "./contract-create/contract-create.component";
import { ContractEditComponent } from "./contract-edit/contract-edit.component";
import { ContractDeleteComponent } from "./contract-delete/contract-delete.component";
import { ContractDetailsComponent } from "./contract-details/contract-details.component";
import { actionsGuard } from "../shared/guards/actions.guard";

export const contractRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: ContractListComponent, canActivate: [actionsGuard] },
  { path: 'create', component: ContractCreateComponent, canActivate: [actionsGuard] },
  { path: 'edit/:id', component: ContractEditComponent, canActivate: [actionsGuard] },
  { path: 'delete/:id', component: ContractDeleteComponent, canActivate: [actionsGuard] },
  { path: 'details/:id', component: ContractDetailsComponent, canActivate: [actionsGuard] },
]
